import { BASE_URL, WorkOSAuthResponse } from "./workos";

export const sendCode = async ({
  email,
  captcha,
  invitationToken = ""
}: {
  email: string;
  captcha: string;
  invitationToken?: string;
}) => {
  const res = await fetch(`${BASE_URL}/api/workos/magic-auth/start`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, captcha, invitationToken })
  });

  if (!res.ok) {
    const body = await res.json();
    throw new Error(body.error || "Failed to send code");
  }

  const result = (await res.json()) as {
    id: string;
    email: string;
    expiresAt: string;
  };
  return result;
};

export const verifyCode = async ({
  email,
  code,
  invitationToken
}: {
  email: string;
  code: string;
  invitationToken?: string;
}) => {
  const res = await fetch(`${BASE_URL}/api/workos/magic-auth/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, code, invitationToken })
  });

  if (!res.ok) {
    const body = await res.json();
    throw new Error(body.error || "Failed to verify code");
  }

  const result = (await res.json()) as WorkOSAuthResponse;
  return result;
};

export const RETRY_TIMEOUT = 30 * 1000;
export const RETRY_LIMIT = 5;
